import React, { useEffect, useRef, useState, memo } from "react";
import classNames from "classnames";
import { DragDropContext } from "react-beautiful-dnd";

import Dialog from "components/Dialog";
import "./style.scss";
import Strap from "../Strap";
import ScrollDraggable from "../../ScrollDraggable";

const ZoomDialog = () => {
  const [state, setState] = useState({
    showDialog: false,
    scale: 2,
  });

  const el = useRef();

  const handelOnClose = () => {
    const { showDialog } = state;
    setState({ ...state, showDialog: !showDialog, scale: 2 });
  };

  const renderDialogBody = () => {
    const { scale } = state;
    const zoomClasses = classNames("ZoomDialog__image", {
      active: scale > 1,
    });

    let mouseMove = false;

    const onMouseDown = () => {
      mouseMove = false;
    };

    const onMouseUp = () => {
      !mouseMove && setState({ ...state, showDialog: false });
    };

    const onMouseMove = () => {
      mouseMove = true;
    };

    return (
      <div
        className="ZoomDialog"
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseMove={onMouseMove}
      >
        <ScrollDraggable>
          <div className={zoomClasses} style={{ transform: `scale(${scale})` }}>
            <DragDropContext>
              <Strap slider />
            </DragDropContext>
          </div>
        </ScrollDraggable>
      </div>
    );
  };

  useEffect(() => {
    const body = document.querySelector("body");
    if (body) {
      if (state.showDialog) {
        body.style.overflow = "hidden";
      } else {
        body.style.overflow = "";
      }
    }
  }, [state.showDialog]);

  const { showDialog } = state;

  return (
    <div className="StrapWrapZoom" ref={el}>
      <div
        className="Product__content-zoom"
        onClick={() => setState({ ...state, showDialog: !showDialog })}
      />
      <Dialog
        isOpen={showDialog}
        onCloseDialog={handelOnClose}
        renderBody={renderDialogBody}
      />
    </div>
  );
};

export default memo(ZoomDialog);
